export default "__VITE_ASSET__69b2d97d__"